import { useEffect, useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { useApi } from "@/lib/api";
import { Markdown } from "@/components/Markdown";
import { langName } from "@/components/Translate";
import { getLang, t } from "@/i18n";

export function TranslatedDoc({ sop }) {
  const api = useApi();
  const lang = getLang();
  const [tr, setTr] = useState(null);
  const [state, setState] = useState("idle");
  const [original, setOriginal] = useState(false);
  useEffect(() => {
    if (!sop.markdown || sop.status === "processing") return;
    let live = true;
    setState("loading");
    api.get(`/sops/${sop.id}/translation`, { params: { lang } })
      .then((r) => { if (live) { setTr(r.data.translated ? r.data : null); setState("done"); } })
      .catch(() => live && setState("error"));
    return () => { live = false; };
  }, [api, sop.id, sop.markdown, sop.title, sop.status, lang]);

  const from = tr ? langName(tr.source_language) : "";
  return (
    <div className="stack-sm">
      {state === "loading" && lang !== "en" && <p className="text-xs faint flex items-center gap-1.5" data-testid="sop-translating"><Loader2 size={12} className="animate-spin" /> {t("Translating…")}</p>}
      {state === "error" && lang !== "en" && <p className="text-xs faint" data-testid="sop-translate-error">{t("Translation is unavailable right now. Showing the original.")}</p>}
      {tr && (
        <p className="text-xs faint flex flex-wrap items-center gap-1.5" title={t("Translations are for accessibility; original text remains available.")} data-testid="sop-translate-label">
          <Languages size={12} /> {t(original ? "Original in {lang}" : "Translated from {lang}", { lang: from })}
          <button className="text-[var(--accent-primary)] font-semibold hover:underline" onClick={() => setOriginal(!original)} data-testid="sop-translate-toggle">
            {t(original ? "View translated" : "View original")}
          </button>
        </p>
      )}
      <Markdown testid="sop-markdown">{tr && !original ? tr.markdown : sop.markdown}</Markdown>
    </div>
  );
}
